<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <CRow>
        <CCol cols="12" md="12" lg="12">
          <b-button variant="primary" class="mb-4" v-b-modal.modal-input-koordinator :disabled="!allow">
            <CIcon name="cil-plus" />
            {{ $store.state.table.tambahModal }}
          </b-button>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
            <template #Actions="{ item }">
              <td>
                <b-button
                  variant="warning"
                  class="mr-1"
                  v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                  v-b-modal.modal-edit-koordinator
                  @click="(data = item), (edit = !edit)"
                  :disabled="!allow"
                  ><CIcon name="cil-pencil" /> {{ item.actions }}</b-button
                >
                <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-koordinator @click="data = item" :disabled="!allow"
                  ><CIcon name="cil-trash" /> {{ item.actions }}</b-button
                >
              </td>
            </template>
          </CDataTable>
          <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
        </CCol>
      </CRow>
    </CCol>
    <modalInput @alertFromChild="triggerAlert($event)" :mitra="listMitra" :provinsi="listProvinsi" />
    <modalEdit :data="data" :mitra="listMitra" :provinsi="listProvinsi" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modalDelete @alertFromChild="triggerAlert($event)" :data="data" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  props: ["activeTab"],
  name: "Posisi",
  data() {
    return {
      edit: false,
      listMitra: [],
      listProvinsi: [],
      data: {},
      items: [],

      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    isHrd() {
      return this.$store.state.role_aktif.kodeRole == "admin_hrd";
    },
    isSuper() {
      return this.$store.state.role_aktif.kodeRole == "super" || this.$store.state.role_aktif.kodeRole == "super_user";
    },
    allow() {
      return this.isHrd || this.isSuper;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          _classes: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKoordinator",
          label: this.$store.state.table.koordinator,
          _style: "max-width: 30%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "kodeKoordinator",
          label: this.$store.state.table.kode,
          _style: "width: 10%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "alamatKoordinator",
          label: this.$store.state.table.alamat,
          _style: "max-width: 30%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "noHpKantor",
          label: this.$store.state.table.notelp,
          _style: "width: 15%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.aksi,
          _style: "width: 10%",
          _classes: "text-center",
          filter: false,
          sorter: false,
        },
      ];
      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
  },
  // mounted() {
  //   this.getDatas();
  //   this.getProvinsi();
  //   this.getMitra();
  // },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    activeTab: function (newVal) {
      if ((this.isSuper && newVal === 1) || (!this.isSuper && newVal === 0)) {
        this.getDatas();
        this.getProvinsi();
        this.getMitra();
      }
    },
    "$store.state.cabang_aktif"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listKoordinator = await vm.$axios.post("koordinator/listPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listKoordinator", listKoordinator);
      vm.items =
        listKoordinator.data.status == 200
          ? listKoordinator.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
              };
            })
          : [];
      vm.totalRows = parseInt(listKoordinator.data.count);
      vm.loading = false;
    },
    async getProvinsi() {
      let vm = this;
      let listProvinsi = await vm.$axios.get("provinsi/list");
      vm.listProvinsi =
        listProvinsi.data.status == 200
          ? listProvinsi.data.data.map((item) => {
              item.namaProvinsi = item.namaProvinsi.toUpperCase();
              return item;
            })
          : [];
    },
    async getMitra() {
      let vm = this;
      let listMitra = await vm.$axios.get("mitra/list");
      vm.listMitra = listMitra.data.status == 200 ? listMitra.data.data : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.getDatas();
      vm.$store.commit("set_alert", event);
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
